"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _AlertingBannerModal = require("./AlertingBannerModal.style");
var _WarningIcon = _interopRequireDefault(require("./icons/WarningIcon"));
const AlertingBannerModal = _ref => {
  let {
    testId,
    onClose,
    onContinue = () => {},
    bodyMessages,
    title,
    ModalComp,
    footerButtonsText = [],
    shouldHideIcon = false,
    isTextLeftAlign = false
  } = _ref;
  const getFooterContent = () => /*#__PURE__*/_react.default.createElement(_AlertingBannerModal.Footer, null, footerButtonsText && /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    testId: "modal-footer-cancel-btn",
    onClick: onClose,
    variant: "Tertiary"
  }, footerButtonsText[0]), footerButtonsText[1] && /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    testId: "modal-footer-primary-btn",
    onClick: onContinue,
    variant: "Primary"
  }, footerButtonsText[1]));
  const parseHtmlElement = htmlString => {
    const dom = document.createElement('span');
    dom.innerHTML = htmlString;
    return /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: dom.innerHTML
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_AlertingBannerModal.ModalContainer, null, /*#__PURE__*/_react.default.createElement(ModalComp, {
    testId: testId,
    ariaLabel: title,
    isOpen: true,
    variant: "Small",
    version: "V2",
    onDismiss: onClose,
    allowOverflow: true,
    header: {
      visible: true,
      title
    },
    footer: {
      visible: true,
      FooterContent: () => getFooterContent()
    }
  }, /*#__PURE__*/_react.default.createElement(_AlertingBannerModal.Wrapper, null, /*#__PURE__*/_react.default.createElement(_AlertingBannerModal.Container, {
    isTextLeftAlign: isTextLeftAlign
  }, /*#__PURE__*/_react.default.createElement(_AlertingBannerModal.IconWrapper, null, !shouldHideIcon && /*#__PURE__*/_react.default.createElement(_WarningIcon.default, null)), /*#__PURE__*/_react.default.createElement(_AlertingBannerModal.MessagesWrapper, {
    isTextLeftAlign: isTextLeftAlign
  }, bodyMessages.map((message, index) => /*#__PURE__*/_react.default.createElement(_uiKit.Text.Body, {
    "data-testid": "alerting-modal-message",
    key: index
  }, parseHtmlElement(message || ''))))))));
};
var _default = exports.default = AlertingBannerModal;